import { useQuery } from '@tanstack/react-query';
import { getRFAverageCharts, RFChartsResponse } from '../../services/network/form30RFCharts-api';

interface UseFetchRFChartsParams {
    year: number | null;
    enabled?: boolean;
}

export const useFetchRFCharts = ({
    year,
    enabled = true
}: UseFetchRFChartsParams) => {
    const shouldFetch = enabled && !!year;

    const { data, isLoading, isError, error, refetch } = useQuery<RFChartsResponse>({
        queryKey: ['rfCharts', year],
        queryFn: async () => {
            if (!year) {
                throw new Error('Отсутствует год');
            }
            return await getRFAverageCharts(year);
        },
        enabled: shouldFetch,
        staleTime: 5 * 60 * 1000,
        retry: 2,
    });

    return {
        rfChartsData: data?.data || null,
        physicalGroupsData: data?.data?.physicalGroups || null,
        healthGroupsData: data?.data?.healthGroups || null,
        rehabilitationData: data?.data?.rehabilitation || null,
        childCountData: data?.data?.childCount || null,
        isLoading,
        isError,
        error,
        refetch
    };
};
